/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import messages from "./messages/messages.json";
import {
  getTranslatedMessages,
  getTriAppConfig,
} from "@tririga/tririga-react-components";
import { NavConfig } from "../utils"

const VERSION = process.env.REACT_APP_VERSION;

const baseMessages = {
  ...messages,
};

let appMessages = null;

export const APP_ABOUT = "APP_ABOUT";
export const APP_HOME = "APP_HOME";
export const APP_HELP = "APP_HELP";
export const APP_LOGOUT = "APP_LOGOUT";
export const APP_MULTI_LOGOUT = "APP_MULTI_LOGOUT";
export const APP_MULTI_LOGOUT_OPEN_SESSIONS = "APP_MULTI_LOGOUT_OPEN_SESSIONS";
export const APP_MULTI_LOGOUT_ALL_SESSIONS = "APP_MULTI_LOGOUT_ALL_SESSIONS";
export const APP_MULTI_LOGOUT_THIS_SESSION = "APP_MULTI_LOGOUT_THIS_SESSION";
export const APP_CANCEL = "APP_CANCEL";
export const APP_TITLE = "APP_TITLE";
export const APP_NO_COMPANY = "APP_NO_COMPANY";
export const USER_USER = "USER_USER";
export const USER_PROFILE = "USER_PROFILE";
export const USER_MANAGE = "USER_MANAGE";
export const PROJ_SWITCH = "PROJ_SWITCH";
export const PROJ_SELECT = "PROJ_SELECT";
export const PROJ_RECORD = "PROJ_RECORD";
export const PROJ_RECENT = "PROJ_RECENT";
export const PROJ_SEARCH = "PROJ_SEARCH";
export const PROJ_DETAILS = "PROJ_DETAILS";
export const APP_PAGE_TITLE = "APP_PAGE_TITLE";
export const PROJ_MENU = "PROJ_MENU";
export const EXPAND = "EXPAND";
export const CLOSE = "CLOSE";
export const NO_SESSION_HEADING = "NO_SESSION_HEADING";
export const NO_SESSION_BODY = "NO_SESSION_BODY";
export const NO_SESSION_LOGIN = "NO_SESSION_LOGIN";
export const OPEN_MENU = "OPEN_MENU";
export const INVALID_CREDENTIALS = "INVALID_CREDENTIALS";
export const APP_ERROR = "APP_ERROR";
export const APP_ERROR_MSG = "APP_ERROR_MSG";
export const SESSION_TIMEOUT = "SESSION_TIMEOUT";
export const SESSION_TIMEOUT_MSG = "SESSION_TIMEOUT_MSG";
export const APP_LOGIN = "APP_LOGIN";
export const SESSION_RENEW = "SESSION_RENEW";
export const LOGIN_MSG = "LOGIN_MSG";
export const APP_USERNAME = "APP_USERNAME";
export const APP_PASSWORD = "APP_PASSWORD";
export const PASSWORD_PLACEHOLDER = "PASSSWORD_PLACEHOLDER";
export const APP_SWITCH_USER = "APP_SWITCH_USER";
export const SESSION_EXPIRED = "SESSION_EXPIRED";
export const SESSION_EXPIRE_MSG = "SESSION_EXPIRE_MSG";
export const SESSION_LOGIN = "SESSION_LOGIN";
export const CATALOG_MENU = "CATALOG_MENU";
export const SUITE_CATALOG = "SUITE_CATALOG";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CREATE_NEW_PASSWORD = "CREATE_NEW_PASSWORD";
export const APP_NEW_PASSWORD = "APP_NEW_PASSWORD";
export const APP_CONFIRM_NEW_PASSWORD = "APP_CONFIRM_NEW_PASSWORD";
export const APP_CONTINUE = "APP_CONTINUE";
export const APP_ENTER_NEW_PASSWORD = "APP_ENTER_NEW_PASSWORD";
export const APP_ENTER_CONFIRM_NEW_PASSWORD = "APP_ENTER_CONFIRM_NEW_PASSWORD";
export const APP_ERROR_PASSWORD_RULES_NOT_MET =
  "APP_ERROR_PASSWORD_RULES_NOT_MET";
export const APP_PWD_RULES_CONSIST_OF = "APP_PWD_RULES_CONSIST_OF";
export const APP_PWD_RULE_HISTORY_COUNT = "APP_PWD_RULE_HISTORY_COUNT";
export const APP_PWD_RULE_HISTORY_PREVIOUS = "APP_PWD_RULE_HISTORY_PREVIOUS";
export const APP_PWD_RULES_OPTIONAL_CONSIST_OF =
  "APP_PWD_RULES_OPTIONAL_CONSIST_OF";
export const APP_PWD_RULE_NOT_SAME_AS_PREVIOUS =
  "APP_PWD_RULE_NOT_SAME_AS_PREVIOUS";
export const APP_PWD_RULE_MIN_CHARS = "APP_PWD_RULE_MIN_CHARS";
export const APP_PWD_RULE_MAX_CHARS = "APP_PWD_RULE_MAX_CHARS";
export const APP_PWD_RULE_MIN_MAX_CHARS = "APP_PWD_RULE_MIN_MAX_CHARS";
export const APP_PWD_RULE_LOWERCASE_REQ = "APP_PWD_RULE_LOWERCASE_REQ";
export const APP_PWD_RULE_LOWERCASE_OPTIONAL = "APP_PWD_RULE_LOWERCASE_OPTIONAL";
export const APP_PWD_RULE_UPPERCASE_REQ = "APP_PWD_RULE_UPPERCASE_REQ";
export const APP_PWD_RULE_UPPERCASE_OPTIONAL = "APP_PWD_RULE_UPPERCASE_OPTIONAL";
export const APP_PWD_RULE_NUMBER_REQ = "APP_PWD_RULE_NUMBER_REQ";
export const APP_PWD_RULE_NUMBER_OPTIONAL = "APP_PWD_RULE_NUMBER_OPTIONAL";
export const APP_PWD_RULE_SPECIAL_REQ = "APP_PWD_RULE_SPECIAL_REQ";
export const APP_PWD_RULE_SPECIAL_OPTIONAL = "APP_PWD_RULE_SPECIAL_OPTIONAL";
export const APP_PWD_RULE_NOT_CONTAIN_USERNAME = "APP_PWD_RULE_NOT_CONTAIN_USERNAME";
export const APP_ERROR_NEW_PASSWORD_NO_MATCH =
  "APP_ERROR_NEW_PASSWORD_NO_MATCH";
export const APP_SYSTEM_ERROR_PWD = "APP_SYSTEM_ERROR_PWD";
export const NEW_PASSWORD_CREATED = "NEW_PASSWORD_CREATED";
export const APP_CURRENT_PASSWORD = "APP_CURRENT_PASSWORD";
export const APP_ENTER_CURRENT_PASSWORD = "APP_ENTER_CURRENT_PASSWORD";
export const APP_ERROR_CURRENT_PASSWORD_NOT_VALID =
  "APP_ERROR_CURRENT_PASSWORD_NOT_VALID";
export const APP_CURRENT_PASSWORD_ERROR = "APP_CURRENT_PASSWORD_ERROR";

export function getMessage(label) {
  return appMessages[label];
}

export async function initMessages() {
  if (process.env.NODE_ENV==='development') {
      appMessages = baseMessages;
  } else if (!appMessages) {
    try {
      appMessages = await getTranslatedMessages(
        baseMessages,
        getTriAppConfig().appExposedName + VERSION,
        NavConfig.getNavConfigData().userLanguageId
      );
      
      localStorage.setItem("triPlatformNavMessages",JSON.stringify(appMessages));
    } catch (error) {
      alert(
        'Unable to get translations, defaulting to English -' + error
      );
      appMessages = baseMessages;
    }
  }
}